export default __webpack_public_path__ + "static/media/info.365da5dd.svg";